import React from 'react';
import FoldersAndFilesRow from './FoldersAndFilesRow';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DraggableElement from '../util/draggable_element/DraggableElement';
import FolderAndFileTableHeading from './FolderAndFileTableHeading';
const FolderFileDragContainer = _ref => {
  let {
    folders,
    files,
    setFolders,
    setFiles,
    setCurrentFolderId,
    showFolderOrFileDropModal,
    setDraggedElement,
    draggedElement,
    setCurrentAction,
    goToFolderQuery,
    canEditExistingDocumentsOrFolders = true
  } = _ref;
  const {
    t
  } = useTranslation();
  const handleDragStart = data => {
    setDraggedElement({
      ...data
    });
  };
  const renderFolderRows = folders.map(f => {
    return /*#__PURE__*/React.createElement(DraggableElement, {
      userCanDrag: canEditExistingDocumentsOrFolders,
      key: (f.id || f.model_id) + f.name,
      element: f,
      onDragStart: handleDragStart,
      onDrop: showFolderOrFileDropModal,
      setDraggedElement: setDraggedElement,
      draggedElement: draggedElement,
      setCurrentAction: setCurrentAction
    }, /*#__PURE__*/React.createElement(FoldersAndFilesRow, {
      data: f,
      route: 'folders',
      setAllData: setFolders,
      allData: folders,
      setCurrentFolderId: setCurrentFolderId,
      goToFolderQuery: goToFolderQuery,
      canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders
    }));
  });
  const renderFileRows = files.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map(f => {
    return /*#__PURE__*/React.createElement(DraggableElement, {
      userCanDrag: canEditExistingDocumentsOrFolders,
      key: f.id + f.name + 'files',
      element: f,
      onDragStart: handleDragStart,
      onDrop: showFolderOrFileDropModal,
      setDraggedElement: setDraggedElement,
      draggedElement: draggedElement,
      setCurrentAction: setCurrentAction
    }, /*#__PURE__*/React.createElement(FoldersAndFilesRow, {
      data: f,
      route: 'folder_files',
      setAllData: setFiles,
      allData: files,
      canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement(FolderAndFileTableHeading, null), /*#__PURE__*/React.createElement("tbody", null, renderFolderRows, renderFileRows)));
};
export default FolderFileDragContainer;